import { render, staticRenderFns } from "./SmtpCampaignForm.vue?vue&type=template&id=879ca2d2&scoped=true"
import script from "./SmtpCampaignForm.vue?vue&type=script&lang=js"
export * from "./SmtpCampaignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879ca2d2",
  null
  
)

export default component.exports